import React from 'react';
import Gallery from 'react-photo-gallery';

import Row from '../../components/row';
import Title from '../../components/title';

import B1 from './images/DES24.jpg';
import B3 from './images/DES19.jpg';
import B4 from './images/DES23.jpg';
import B5 from './images/DES25.jpg';
import B6 from './images/DES26.jpg';
import B7 from './images/breakfast1.jpg';
import B8 from './images/breakfast2.jpg';
import B9 from './images/breakfast3.jpg';
import B10 from './images/breakfast4.jpg';

const preparePhoto = (urls) => {
  return urls.map(url => ({
    src: url,
    width: 700,
    height: 500,
    aspectRatio: 1.5,
    lightboxImage: {
      src: url
    }
  }))
}

const Breakfast = () => {
    const photos = [B8, B9, B3, B4, B5, B6, B7, B10, B1];
    return (
      <Row>
        <Title title="Nuestros Desayunos" />
        <div>
          <Gallery photos={preparePhoto(photos)} />
        </div>
      </Row>
  )
  };

export default Breakfast;



// WEBPACK FOOTER //
// ./src/home/breakfast/index.js